import React, { useRef, useEffect, useState } from 'react';
import { TextField, Box } from '@mui/material';

function CustomOtpInput({ value, onChange, length = 6 }) {
    const defaultOtp = '672621'; // Default OTP
    const inputRefs = useRef(new Array(length).fill(null));
    const [otp, setOtp] = useState(value || defaultOtp);

    useEffect(() => {
        onChange(otp);
    }, [otp, onChange]);

    const handleInputChange = (index, event) => {
        const newValue = event.target.value;

        if (/^\d*$/.test(newValue)) { // Ensure only digits are allowed
            const updatedOtp = otp.split('');
            updatedOtp[index] = newValue;
            const newOtp = updatedOtp.join('');
            setOtp(newOtp);
            onChange(newOtp);

            // Move focus to the next input if a digit is entered
            if (newValue && index < length - 1) {
                inputRefs.current[index + 1]?.focus();
            }
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace' && !otp[index] && index > 0) {
            // Move focus to the previous input field on Backspace
            inputRefs.current[index - 1]?.focus();
        }
    };

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                gap: { xs: '6px', sm: '8px' }, 
                justifyContent: 'center' 
            }}
        >
            {Array.from({ length }).map((_, index) => (
                <TextField
                    key={index}
                    value={otp[index] || ''}
                    onChange={(e) => handleInputChange(index, e)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    inputProps={{
                        maxLength: 1,
                        style: { textAlign: 'center', fontSize: '1.25rem' },
                    }}
                    variant="outlined"
                    size="small"
                    sx={{
                        width: { xs: '40px', sm: '50px' },
                        height: { xs: '40px', sm: '50px' },
                    }}
                    inputRef={(el) => (inputRefs.current[index] = el)} // store references for auto-focus
                />
            ))}
        </Box>
    );
}

export default CustomOtpInput;
